// Educational articles (static content, SEO pages come later).
export interface Article {
    slug: string
    title: string
    summary: string
    repairCost: string
    replaceSignal: string
}

export const ARTICLES: Article[] = [
    {
        slug: 'frozen-coils',
        title: 'What causes frozen coils?',
        summary:
            'Ice on an AC almost always means restricted airflow or low refrigerant. A clogged filter is the most common — and cheapest — culprit, so always start there before assuming the worst.',
        repairCost: 'Filter: ~$20 DIY · Refrigerant leak: $250–$1,500',
        replaceSignal: 'Repeat freeze-ups on a 12+ year old system usually mean a failing coil.',
    },
    {
        slug: 'hvac-lifespan',
        title: 'How long do HVAC systems last?',
        summary:
            'Most central AC systems last 12–18 years; heat pumps 10–15; furnaces 15–25. Coastal humidity and salt air shorten that. Age alone is not a verdict — maintenance history matters as much.',
        repairCost: 'Annual tune-up: $80–$200',
        replaceSignal: 'Past 15 years, major repairs rarely pay for themselves.',
    },
    {
        slug: 'refrigerant-leaks',
        title: 'Should refrigerant leaks be repaired?',
        summary:
            'A one-time top-up can be reasonable. Recurring leaks are different: refrigerant for older R-410A systems keeps getting pricier, and a leak means the sealed system is compromised.',
        repairCost: 'Leak locate + repair + recharge: $400–$1,600',
        replaceSignal: 'A second leak within a few years is a strong replacement signal.',
    },
    {
        slug: 'repair-vs-replace-cost',
        title: 'The 50% rule for repair vs replace',
        summary:
            'A common industry rule of thumb: when a repair costs more than half the price of a comparable new system — or the system is past ⅔ of its expected life — replacement usually wins on total cost.',
        repairCost: 'Compressor replacement: $1,500–$3,000',
        replaceSignal: 'New system: $6,000–$12,500 installed, minus efficiency savings.',
    },
    {
        slug: 'energy-efficiency',
        title: 'What a high-SEER upgrade actually saves',
        summary:
            'Replacing a SEER 10 unit with a SEER 16+ one typically cuts cooling costs 30–40%. In hot climates that is $300–$600 a year — real money, but rarely enough to justify replacing a healthy system on its own.',
        repairCost: 'No repair needed — this is a planning question.',
        replaceSignal: 'Efficiency savings tip the scale when a big repair is already on the table.',
    },
    {
        slug: 'maintenance-tips',
        title: 'Maintenance that actually matters',
        summary:
            'Change filters every 1–3 months, keep the outdoor coil clear of debris, flush the condensate drain yearly, and book a professional tune-up each spring. That short list prevents the majority of emergency calls.',
        repairCost: 'DIY basics: under $50 a year',
        replaceSignal: 'A well-maintained system earns years of extra life.',
    },
]
